import { Navigate } from "react-router-dom";

/**
 * Bytte (exchange checklists) is now a section on the Samarbeid page.
 * Redirect legacy /exchange links to /custody so users land on Samarbeid with Bytte & Overlevering.
 */
export default function Exchange() {
  return <Navigate to="/custody" replace />;
}
